import { Component, Input, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import {
  Article,
  CompanyDirectorship,
  Director,
  Portfolio,
  Watchlist,
} from '../../../core/models';
import { Company } from '../../../core/models';
import { Router } from '@angular/router';
import { ModalService } from '../../../core/services/modal.service';
import { resetSelectedCompany } from '../../../core/store/company/company.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../../core/store/app.state';
import {
  addCompanyToWatchlist,
  deleteWatchlist,
} from '../../../core/store/watchlist/watchlist.actions';
import {
  addCompanyToPortfolio,
  deletePortfolio,
} from '../../../core/store/portfolio/portfolio.actions';
import { AuthService, UserSubscription } from '../../../modules/auth';
import { methodology } from '../../../core/constants/methodology';
import { LayoutService } from '../../../modules/layout';
@Component({
  selector: 'app-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.scss'],
})
export class CompanyInfoComponent implements OnDestroy {
  displayedColumns: string[] = ['platform', 'text', 'date', 'actions'];
  resultsLength = 0;
  isLoading = false;

  @Input() company: Company;
  @Input() watchlist: Watchlist | null;
  @Input() portfolio: Portfolio | null;
  @Input() news: Article[] | null;
  @Input() subscription: UserSubscription | null;
  constructor(
    private router: Router,
    private location: Location,
    private readonly modalService: ModalService,
    private readonly store: Store<AppState>,
    private authService: AuthService,
    private layout: LayoutService
  ) {}

  openDirectorProfile(company: Company, director: Director) {
    let directorship = company.directorships?.find(
      directorship => directorship.id_director === director.id
    );
    if (!directorship) {
      throw new Error(`Directorship not found for director ${director}`);
    }
    directorship = { ...directorship, company: company };
    this.modalService.openDirectorProfile(directorship);
  }

  toggleToWatchlist(watchlist: Watchlist | null, company: Company): void {
    if (!this.authService.hasActivePlan(['pro', 'enterprise'])) {
      this.layout.showPaywall('Unlock Premium to Access Watchlist Features');
      return;
    }
    if (watchlist) {
      this.store.dispatch(deleteWatchlist({ id: watchlist.id }));
    } else {
      this.store.dispatch(addCompanyToWatchlist({ id_company: company.id }));
    }
  }
  toggleToPortfolio(portfolio: Portfolio | null, company: Company): void {
    if (!this.authService.hasActivePlan(['pro', 'enterprise'])) {
      this.layout.showPaywall('Unlock Premium to Access Portfolio Features');
      return;
    }
    if (portfolio) {
      this.store.dispatch(deletePortfolio({ id: portfolio.id }));
    } else {
      this.store.dispatch(addCompanyToPortfolio({ id_company: company.id }));
    }
  }
  ngOnDestroy(): void {
    this.store.dispatch(resetSelectedCompany());
  }

  goBack() {
    if (window.history.state?.navigationId > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/']).then();
    }
  }

  filterCurrent(directorships: CompanyDirectorship[]) {
    return directorships.filter(
      directorships => directorships.end_date === null
    );
  }

  openHelpPage() {
    window.open('https://www.freefloat.llc/methodologies-faq', '_blank');
  }

  protected readonly methodology = methodology;
}
